export const MODE = {
  dark: {
    bg: "#080808",
    sideBarBg: "#444444",
    contextMenuBg: "#f1f1f1",
    miniMapNode: "#f1f1f1",
    miniMapBg: "#989898",
    miniMapMask: "#e1e1e1",
  },
  light: {
    bg: "#eeeee6",
    sideBarBg: "#d6d6d6",
    contextMenuBg: "#525252",
    miniMapNode: "#525252",
    miniMapBg: "#e1e1e1",
    miniMapMask: "#767676",
  },
};
